module.exports = __webpack_public_path__ + "static/media/display-pic.974f2685.png";